import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

const GEO_URL = "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/switzerland.geojson";

const REGIONS = [
    { code: "Aargau", name: "Aargau" },
    { code: "Appenzell Ausserrhoden", name: "Appenzell Ausserrhoden" },
    { code: "Appenzell Innerrhoden", name: "Appenzell Innerrhoden" },
    { code: "Basel-Landschaft", name: "Basel-Landschaft" },
    { code: "Basel-Stadt", name: "Basel-Stadt" },
    { code: "Bern", name: "Bern" },
    { code: "Fribourg", name: "Fribourg" },
    { code: "Genève", name: "Genève" },
    { code: "Glarus", name: "Glarus" },
    { code: "Graubünden", name: "Graubünden" },
    { code: "Jura", name: "Jura" },
    { code: "Luzern", name: "Luzern" },
    { code: "Neuchâtel", name: "Neuchâtel" },
    { code: "Nidwalden", name: "Nidwalden" },
    { code: "Obwalden", name: "Obwalden" },
    { code: "Schaffhausen", name: "Schaffhausen" },
    { code: "Schwyz", name: "Schwyz" },
    { code: "Solothurn", name: "Solothurn" },
    { code: "St. Gallen", name: "St. Gallen" },
    { code: "Thurgau", name: "Thurgau" },
    { code: "Ticino", name: "Ticino" },
    { code: "Uri", name: "Uri" },
    { code: "Valais", name: "Valais" },
    { code: "Vaud", name: "Vaud" },
    { code: "Zug", name: "Zug" },
    { code: "Zürich", name: "Zürich" },
];

const REGION_CODES = REGIONS.map(r => r.code);
const ITEMS = REGIONS.map(r => ({ id: r.code, name: r.name }));

const SwitzerlandMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{ scale: 7000, center: [8.2, 46.8] }}
            width={800}
            height={600}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => REGION_CODES.includes(geo.properties.name))
                        .map((geo) => {
                            const code = geo.properties.name;
                            const isVisited = visited.includes(code);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(code)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="switzerland"
            analyticsLocationType="switzerland"
            trackingLabel="Switzerland Map"
            storageKey="switzerland_map"
            title="🇨🇭 Switzerland Travel Map"
            subtitle="Click on Swiss cantons you've visited. Or use the checklist below!"
            items={ITEMS}
            noun="Cantons"
            unitLabel="cantons"
            captionUnit="Swiss cantons"
            share={{
                region: 'Switzerland',
                fileName: 'visited-switzerland-map.png',
                trackId: 'switzerland'
            }}
            renderMap={renderMap}
        />
    );
};

export default SwitzerlandMapSection;
